import { Box, Tab, Tabs } from '@mui/material';
import React, { useState } from 'react';
import Stage3AttestationsTab from './Stage3AttestationsTab';
import TeacherLettersTab from './TeacherLettersTab';

const ManagementPage: React.FC = () => {
	const [tab, setTab] = useState(0);

	return (
		<Box sx={{ pr: { sm: 2 }, pb: 4 }}>
			<Tabs
				value={tab}
				onChange={(_, v) => setTab(v)}
				sx={{ mb: 2 }}
			>
				<Tab label='Zaświadczenia III' />
				<Tab label='Listy gratulacyjne (nauczyciele)' />
			</Tabs>
			{tab === 0 && <Stage3AttestationsTab />}
			{tab === 1 && <TeacherLettersTab />}
		</Box>
	);
};

export default ManagementPage;
